// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Pipeline layout constants - single source of truth for canvas positioning.
 */

import { NODE_WIDTH } from '../types'

/** Horizontal gap between nodes when arranged */
const HORIZONTAL_GAP = 80

/** Layout positioning */
export const LAYOUT = {
  startX: 0,
  defaultY: 100,
  stepX: NODE_WIDTH + HORIZONTAL_GAP,
} as const

/** FitView options - used for initial load and after arrange */
export const FIT_VIEW_OPTIONS = {
  padding: 0.5,
  maxZoom: 0.75,
  duration: 300,
} as const

/** Zoom constraints */
export const ZOOM = {
  min: 0.3,
  max: 1.5,
} as const
